/**
 * @file   src\store\actions\authAction.ts
 * @brief  This file is responsible for creating asynchronous api call for auth slice.
 * @date   May, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../config/axiosConfig';
import { IAuthRequest, IResetValidationRequest } from '../../interfaces/authInterface';
import { AuthApi } from '../../utils/apiUrls';
import { setLocalStorage } from '../../utils/helper';

// User authentication api call.
export const validateUser = createAsyncThunk('/adminAuth/validateUser', async (loginRequest: IAuthRequest, { rejectWithValue }) => {
  try {
    const { data } = await axios.post(AuthApi.LOGIN, loginRequest);
    if(data.error === 0) {
      if(loginRequest.adminUserType === 'CARWASHOWNER') {
        setLocalStorage('CARWASH_OWNER_DATA',JSON.stringify(data.data))
        localStorage.removeItem('CARWASH_ADMIN_DATA')
      } else {
        setLocalStorage('CARWASH_ADMIN_DATA',JSON.stringify(data.data));
        localStorage.removeItem('CARWASH_OWNER_DATA')
      }
    }
    return data;
  } catch (error: any) {
    return rejectWithValue(error.data);
  }
});

// // User logout api call.
// export const userLogout = createAsyncThunk('/user/userLogout', async (_, { rejectWithValue }) => {
//   try {
//     const { data } = await axios.post(AuthApi.LOGOUT);
//     return data;
//   } catch (error: any) {
//     return rejectWithValue(error.data);
//   }
// });
